import React from "react";
import { Modal } from "antd";

const Addkeyword = ({ isaddModalOpen, setIsaddModalOpen }) => {
  const handleOk = () => {
    setIsaddModalOpen(false);
  };
  const handleCancel = () => {
    setIsaddModalOpen(false);
  };
  return (
    <>
      <Modal
        open={isaddModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        className="addkeyword-modal"
        centered={true}
        width="35%"
      >
        <div className="modal-content">
          <h2 className="fw-bold text-medium-black text-center">
            Add Keywords
          </h2>
          <div className="template-div v-center h-center flex-column">
            <h4 className="text-medium-black fw-normal">Template Name</h4>
            <input type="text" placeholder="Type..." className="modal-input mt-3" />
            <div className="modal-bottom-btns d-flex gap-2">
              <button className="modal-dark-btn" onClick={handleCancel}>
                Close
              </button>
              <button className="modal-dark-btn" onClick={handleOk}>
                Apply
              </button>
              <button className="modal-trans-btn">Reset</button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Addkeyword;
